module.exports = __webpack_public_path__ + "static/img/d739f89.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/simulate/images/bg.png
// module id = 692
// module chunks = 2